var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"illustration"},[_vm._v("🤔")]),_c('h1',{staticClass:"error-code"},[_vm._v("404")]),_c('p',{staticClass:"error-text"},[_vm._v("抱歉，页面未找到")])])
}]

export { render, staticRenderFns }